import {CreateOrderData, EventData, OrderData, SegmentsDiscounts} from "@/@types/api";

function getFireUrl(apiUrl: string) {
    return apiUrl
        .replace('https://api.vegas-ticket.ru', '')
        .replace(/[/]/g, '-')
        .replace(/[.!:]/g, '')
}

export const API_URL = process.env.VUE_APP_API_URL ?? ''
export const FIRE_URL = getFireUrl(API_URL)

const configAuth = {
    auth: {
        // берем корневой домен, например vegas-hall.ru
        username: '', // todo через несколько дней убрать, когда кеш у клиентов удалится и всегда будет стартер передавать домен
        password: ''
    }
}

export function setAuthLogin(login: string) {
    configAuth.auth.username = login
}

type ApiResponse<T> = {
    data: T
}

function getAuthHeaders(): HeadersInit {
    if (!configAuth.auth.username && !configAuth.auth.password)
        return {}

    return {
        Authorization: `Basic ${btoa(`${configAuth.auth.username}:${configAuth.auth.password}`)}`
    }
}

function addQueryParams(url: string, params: Record<string, string | number | boolean>): string {
    const searchParams = new URLSearchParams()

    for (const key in params)
        searchParams.set(key, String(params[key]))

    const queryString = searchParams.toString()
    if (!queryString)
        return url

    return `${url}${url.includes('?') ? '&' : '?'}${queryString}`
}

async function requestJson<T>(url: string, init?: RequestInit): Promise<ApiResponse<T>> {
    const response = await fetch(url, {
        ...init,
        headers: {
            ...getAuthHeaders(),
            ...init?.headers
        }
    })

    if (!response.ok)
        throw new Error(`Request failed with status ${response.status}`)

    return response.json()
}

// null нет данных, undefined ошибка
export async function getEvent(eventId: string, debugKey = ""): Promise<EventData | null | undefined> {
    // if (!eventId) return undefined;
    //return (await requestJson<EventData>(`${API_URL}/events/${eventId}`)).data

    try {
        // todo тут можно добавить несколько попыток оптравить запрос
        const url = debugKey
            ? addQueryParams(`${API_URL}/events/${eventId}`, {debug: debugKey})
            : `${API_URL}/events/${eventId}`

        return (await requestJson<EventData>(url)).data
    } catch (error) {

        return undefined
        //
        // // error.response  - сервер ответил, но не 2хх (валидные коды можно задать в конфиге вызова и сделать 404 валидным)
        // if (error?.response?.status === 404) {
        //     return null
        //
        // } else if (error.request) {
        //     // The request was made but no response was received
        //     // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        //     // http.ClientRequest in node.js
        //     throw Error
        // } else {
        //     // Something happened in setting up the request that triggered an Error
        //     throw Error
        // }

    }

}

// export async function createOrder(data: CreateOrderData): Promise<OrderData> {
//
//     const result = (await requestJson<OrderData>(`${API_URL}/online-orders`, {
//         method: 'POST',
//         headers: {'Content-Type': 'application/json'},
//         body: JSON.stringify(data)
//     })).data as OrderData | undefined
//     if (result?.payUrl?.includes('http'))
//         return result
//     else
//         throw Error('Invalid createOrder result')
// }

export async function createOnlineOrder(data: CreateOrderData, sbp = false): Promise<OrderData> {

    return (await requestJson<OrderData>(addQueryParams(`${API_URL}/orders`, {sbp}), {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    })).data

}

// export function cancelOrder(orderId) {
//      //requestJson(`${ROOT_URL}order_cancel`, orderId)
// }


export async function getPromocodeData(eventId: string, promocode: string, segments: number[]): Promise<SegmentsDiscounts> {
    const result = await requestJson<Record<string, number>>(
        addQueryParams(`${API_URL}/promocode/${eventId}/${promocode}`, {segments: segments.join(',')})
    )

    return result.data as unknown as SegmentsDiscounts

}
